import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";
import dummyImage from "assets/images/userDummy.png";

export default function subscriptionTableData({ peopleList }) {
  const User = ({ image, name, contact }) => {
    const imageSource = image ? image : dummyImage;
    return (
      <MDBox display="flex" alignItems="center" lineHeight={1}>
        <MDAvatar src={imageSource} alt={name} size="sm" />
        <MDBox ml={2} lineHeight={1}>
          <MDTypography display="block" variant="button" fontWeight="medium">
            {name}
          </MDTypography>
          <MDTypography variant="caption">{contact}</MDTypography>
        </MDBox>
      </MDBox>
    );
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
    return date;
  };

  return {
    columns: [
      { Header: "User", accessor: "user", width: "40%", align: "left" },
      { Header: "Plan", accessor: "plan", align: "left" },
      { Header: "Plan Price", accessor: "plan_price", align: "left" },
      { Header: "Status", accessor: "status", align: "center" },
      { Header: "Purchased At", accessor: "purchased", align: "center" },
      { Header: "Expiry Date", accessor: "expiry_date", align: "center" },
    ],

    rows: peopleList?.map((person) => ({
      user: <User image={person?.profile} name={person?.name} contact={person?.contactNumber} />,
      plan: (
        <MDTypography component="span" variant="caption" color="text" fontWeight="medium">
          {person?.displayName}
        </MDTypography>
      ),
      plan_price: (
        <MDTypography component="span" variant="caption" color="text" fontWeight="medium">
          {person?.displayPrice}
        </MDTypography>
      ),
      status: (
        <MDBox ml={-1}>
          <MDBadge
            badgeContent={person?.status ? "Active" : "Expired"}
            color={person.status ? "success" : "dark"}
            variant="gradient"
            size="sm"
          />
        </MDBox>
      ),
      purchased: (
        <MDTypography component="span" variant="caption" color="text" fontWeight="medium">
          {formatDate(person?.startDate)}
        </MDTypography>
      ),
      expiry_date: (
        <MDTypography component="span" variant="caption" color="text" fontWeight="medium">
          {formatDate(person?.endDate)}
        </MDTypography>
      ),
    })),
  };
}
